import React from 'react';
import styled from 'styled-components';
import { Button, ModalAvatar, ModalContent, ModalFooter, ModalForm, ModalHeader, ModalLayout, ModalText, ModalTitle, UserTableDataProps } from 'components';
import { toRem } from 'design';
import { formatInviteRecipient } from 'utils';

interface IConfirmResendInvite {
  employee?: UserTableDataProps;
  onResend: () => void;
  onClose: () => void;
  isLoading: boolean;
}

// Modal
const StyledModalHeader = styled(ModalHeader)`
  padding-bottom: ${toRem(44)};
`;

const HeaderContent = styled.div`
  flex-flow: column nowrap;
  justify-items: center;
  align-items: center;
  width: 100%;

  > * {
    margin-bottom: 0;
  }
`;

const Message = styled(ModalText)`
  margin-bottom: ${toRem(27.5)};
  word-wrap: break-word;
`;

const ConfirmResendInvite = ({ employee, onClose, onResend, isLoading }: IConfirmResendInvite) => (
  <ModalLayout isActive onClose={onClose}>
    <StyledModalHeader>
      <ModalAvatar image={employee?.avatarUrl} username={employee?.username || ''} hasPaymentMethod={false} />
      <HeaderContent>
        <ModalTitle>{employee?.username}</ModalTitle>
      </HeaderContent>
    </StyledModalHeader>

    <ModalContent>
      <Message>This user will receive another invitation to {employee?.inviteRecipient && formatInviteRecipient(employee?.inviteRecipient)}. Are you sure you'd like to resend?</Message>
      <ModalForm>
        <ModalFooter columns={2}>
          <Button appearance="white" size="large" label="Cancel" onClick={onClose} />
          <Button appearance="primary" size="large" label="Resend Invite" onClick={onResend} isProcessing={isLoading} />
        </ModalFooter>
      </ModalForm>
    </ModalContent>
  </ModalLayout>
);

export default ConfirmResendInvite;
